import { toast } from "react-toastify";

export const copyToClipboard = (text = window.location.href) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success("リンクをコピーしました！");
    })
    .catch(() => {
      toast.error("コピーに失敗しました");
    });
};
